import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Helmet } from 'react-helmet-async';
import { BlogPost as BlogPostType } from '../types';

const BlogPost = () => {
  const { slug } = useParams<{ slug: string }>();
  const [post, setPost] = useState<BlogPostType | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // TODO: Fetch blog post from API endpoint when ready
    // Example: const response = await api.get(`/api/blog/${slug}`);
    // setPost(response.data);
    // setLoading(false);
    
    // Mock data for now
    setTimeout(() => {
      setPost({
        id: 1,
        title: 'Getting Started with Freelancing',
        excerpt: 'Tips for Filipino freelancers starting their journey...',
        slug: slug || '',
        content: `# Getting Started with Freelancing

This is a sample blog post about getting started with freelancing as a Filipino creator.

## Why Freelance?

Freelancing offers flexibility and the opportunity to work with clients from around the world.

## Getting Started

1. Build your portfolio
2. Join freelancing platforms
3. Network with other freelancers
4. Keep learning and improving

Good luck on your journey!`,
        created_at: '2024-01-15',
      });
      setLoading(false);
    }, 500);
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Loading...</div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Post not found</div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>AlonForge Solutions | {post.title}</title>
        <meta name="description" content={post.excerpt} />
      </Helmet>

      <article className="min-h-screen bg-gray-50 py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
            <h1 className="text-4xl font-bold mb-4 text-gray-800">
              {post.title}
            </h1>
            <p className="text-gray-600 mb-8">
              {new Date(post.created_at).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </p>
            <div className="prose prose-lg max-w-none">
              {post.content && <ReactMarkdown>{post.content}</ReactMarkdown>}
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

export default BlogPost;

